import { jsx as a } from "react/jsx-runtime";
import { AudioPlayerType as s, AudioPlayer as e } from "@nextgen-web-framework/all";
const c = (o) => {
  const { audio_file: r } = o, t = {
    srcList: [
      {
        src: r.url,
        type: s.MP3
      }
    ],
    trackConfig: {}
  };
  return /* @__PURE__ */ a(e, { ...t, controlsList: "nodownload noplaybackrate" });
};
export {
  c as default
};
//# sourceMappingURL=AudioPlayer.js.map
